<template lang="pug">
.l-article-scroll.nano
  .l-article-scroll__inner.nano-content
    slot
</template>

<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'

.l-article-scroll
  position relative
  wh()
  +sp()
    overflow scroll
    scrolltouch()
</style>

<style lang="stylus">
  .l-article-scroll
    .nano-pane
      z-index 100
</style>
<script>
import { defineComponent, computed, ref, onMounted, reactive ,watch ,nextTick } from "vue"
import { useStore } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import $ from 'jquery'
import 'nanoscroller'

export default defineComponent({
  name:'ArticleScroll',

  components:{},

  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()

    onMounted(()=>{
      nextTick(()=>{
        //PCサイズでかつ、タッチイベントがない時はnanoScrollerを使う。
        if(store.browser.state.responsive == 'pc' && !store.browser.isTouch){
          setTimeout(() => {
            $('.l-article-scroll.nano').nanoScroller()  
          }, 100);
        }
      })
    })
    
    return{
    }
  }
})
</script>
